import { Directive, HostListener } from '@angular/core';
import { EditInPlaceComponent } from '../edit-in-place/edit-in-place.component';

@Directive({
  selector: '[hsEditableOnEnter]'
})
export class EditableOnEnterDirective {

  constructor(private editInPlace: EditInPlaceComponent) { }

  @HostListener('keyup.enter')
  onEnter() {
    this.editInPlace.toViewMode();
  }
}
